import React from 'react';
import Header from '../../view/Header';
import Footer from '../../view/Footer';


const Layout = ({ children }) => {
    return (
        <div>
            <Header/>
            <main>
                {children}
            </main>
            <Footer/>
        </div>
    );
};

export default Layout;
